import { render, staticRenderFns } from "./sub.vue?vue&type=template&id=083365f2&scoped=true&"
import script from "./sub.vue?vue&type=script&lang=js&"
export * from "./sub.vue?vue&type=script&lang=js&"
import style0 from "./sub.vue?vue&type=style&index=0&id=083365f2&scoped=true&lang=css&"
import style1 from "./sub.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083365f2",
  null
  
)

export default component.exports